import { render, staticRenderFns } from "./AstroCalendarParm.vue?vue&type=template&id=546e610f&"
import script from "./AstroCalendarParm.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarParm.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarParm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546e610f')) {
      api.createRecord('546e610f', component.options)
    } else {
      api.reload('546e610f', component.options)
    }
    module.hot.accept("./AstroCalendarParm.vue?vue&type=template&id=546e610f&", function () {
      api.rerender('546e610f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/共時曆/AstroCalendarParm.vue"
export default component.exports